import { useState } from 'react'

import { copySecretToClipboard, copyToClipboard } from '~/utils/copyToClipboard'

export function useCopyValue(successMessage?: string) {
  const [isCopied, setIsCopied] = useState(false)

  const markCopied = () => {
    setIsCopied(true)
    setTimeout(() => {
      setIsCopied(false)
    }, 1000)
  }

  const handleCopy = (value: string, message?: string) => {
    if (!value) throw new Error('Value is required')
    copyToClipboard(value, message ?? (successMessage || 'Copied'))
    markCopied()
  }

  const handleCopySecret = (value: string, message?: string) => {
    if (!value) throw new Error('Value is required')
    copySecretToClipboard(value, message ?? (successMessage || 'Copied'))
    markCopied()
  }

  return { isCopied, handleCopy, handleCopySecret }
}
